import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/globals.css';

import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

import AuthGuard from './components/auth/AuthGuard';
import AppShell from './components/layout/AppShell';

import SplashPage from './pages/SplashPage';
import Dashboard from './pages/Dashboard';
import WorkoutsPage from './pages/WorkoutsPage';
import WorkoutBuilderPage from './pages/WorkoutBuilderPage';
import WorkoutDetailPage from './pages/WorkoutDetailPage';
import SchedulePage from './pages/SchedulePage';
import FeedPage from './pages/FeedPage';
import ProfilePage from './pages/ProfilePage';
import AthleteProfilePage from './pages/AthleteProfilePage';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HashRouter>
          <Routes>
            <Route path="/" element={<SplashPage />} />
            <Route
              path="/app"
              element={
                <AuthGuard>
                  <AppShell />
                </AuthGuard>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="workouts" element={<WorkoutsPage />} />
              <Route path="workouts/:id" element={<WorkoutDetailPage />} />
              <Route path="workout/new" element={<WorkoutBuilderPage />} />
              <Route path="schedule" element={<SchedulePage />} />
              <Route path="feed" element={<FeedPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="athlete/:athleteId" element={<AthleteProfilePage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </HashRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
